import React, { useEffect, useState } from "react";
import { Loader } from "./components/Loader";
import { uploadToMinio, getMinioFileUrl, deleteFromMinio } from "./OSModal";
import { ENDPOINTS } from "./endpoints";

function getQueryParam(param: string): string | null {
  if (typeof window === 'undefined') return null;
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

// Função utilitária para formatar data/hora local no padrão 'YYYY-MM-DD HH:mm:ss'
function formatDateTimeLocal(date: Date) {
  return date.getFullYear() + '-' +
    ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
    ('0' + date.getDate()).slice(-2) + ' ' +
    ('0' + date.getHours()).slice(-2) + ':' +
    ('0' + date.getMinutes()).slice(-2) + ':00';
}

// Definir tipo para os dados da OS
interface OSData {
  id: number;
  status_descricao: string;
  descricao_servico_executar?: string;
  materiais_necessarios?: string;
  equipamentos_necessarios?: string;
  profissionais_envolvidos?: string;
  departamento_descricao?: string;
  local_descricao?: string;
  solicitante_nome?: string;
  prioridade_descricao?: string;
  descricao_os?: string;
  gestor_id?: number;
  executor_id?: number;
  data_abertura?: string;
  url_foto?: string;
  typebot_url?: string;
  // ...adicione outros campos conforme necessário
}

export default function OSMobileView() {
  const [loading, setLoading] = useState(true);
  const [osData, setOsData] = useState<OSData | null>(null);
  const unidade = getQueryParam('unit') || '';
  const osId = getQueryParam('os') || '';
  const action = getQueryParam('action') || '';

  // Estado para campos de distribuição
  const [executores, setExecutores] = useState<{id: number, nome: string}[]>([]);
  const [obsValidador, setObsValidador] = useState("");
  const [executorSelecionado, setExecutorSelecionado] = useState("");
  const [prioridadeSelecionada, setPrioridadeSelecionada] = useState("");
  const [distribuindo, setDistribuindo] = useState(false);
  const [toast, setToast] = useState<{ open: boolean, message: string, type?: 'error' | 'success' }>({ open: false, message: '', type: 'error' });
  const [distribuidaComSucesso, setDistribuidaComSucesso] = useState(false);
  const [executorNome, setExecutorNome] = useState("");
  const [aceitando, setAceitando] = useState(false);
  const [aceitaComSucesso, setAceitaComSucesso] = useState(false);
  const [dataHoraVisita, setDataHoraVisita] = useState<Date | null>(null);

  // Estado para execução
  const [descServico, setDescServico] = useState("");
  const [materiais, setMateriais] = useState("");
  const [equipamentos, setEquipamentos] = useState("");
  const [profissionais, setProfissionais] = useState("");
  const [fotosExec, setFotosExec] = useState<{ id: number; localUrl: string; file: File | null }[]>([
    { id: 1, localUrl: "", file: null },
    { id: 2, localUrl: "", file: null },
    { id: 3, localUrl: "", file: null },
  ]);
  const [finalizando, setFinalizando] = useState(false);
  const [cancelando, setCancelando] = useState(false);
  const [gravando, setGravando] = useState(false);
  const [finalizadaComSucesso, setFinalizadaComSucesso] = useState(false);
  const [canceladaComSucesso, setCanceladaComSucesso] = useState(false);

  // Estado para gestores
  const [gestores, setGestores] = useState<{id: number, nome: string}[]>([]);
  const [gestorSelecionado, setGestorSelecionado] = useState("");
  const [prioridadeGestor, setPrioridadeGestor] = useState("");
  const [obsAdmin, setObsAdmin] = useState("");
  const [atribuindo, setAtribuindo] = useState(false);
  const [atribuidoComSucesso, setAtribuidoComSucesso] = useState(false);
  const [nomeGestorAtribuido, setNomeGestorAtribuido] = useState("");

  const [modalFotoAberto, setModalFotoAberto] = useState(false);
  const [fotoModalUrl, setFotoModalUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!unidade || !osId) return;
    setLoading(true);
    fetch(ENDPOINTS.OS_READ, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ unidade, id: osId })
    })
      .then(res => res.json())
      .then(data => {
        if (data && data[0]) {
          setOsData({
            ...data[0],
            data_abertura: data[0].dth_abertura // faz o mapeamento correto
          });
        }
      })
      .finally(() => setLoading(false));
  }, [unidade, osId]);

  // Buscar executores ao carregar se status AGUARDANDO ou action=validate
  useEffect(() => {
    if (
      (osData && osData.status_descricao === "AGUARDANDO") ||
      action === "validate"
    ) {
      fetch(ENDPOINTS.USUARIO_LIST_EXECUTOR, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ unidade })
      })
        .then(res => res.json())
        .then(data => setExecutores(data));
    }
  }, [osData, unidade, action]);

  // Preencher campos ao carregar OS ACEITA
  useEffect(() => {
    if (osData && osData.status_descricao === "ACEITA") {
      setDescServico(osData.descricao_servico_executar || "");
      setMateriais(osData.materiais_necessarios || "");
      setEquipamentos(osData.equipamentos_necessarios || "");
      setProfissionais(osData.profissionais_envolvidos || "");
      // Fotos de execução: carregar URLs do MinIO
      setFotosExec([
        { id: 1, localUrl: getFotoUrl('execucao', 1) + `?v=${Date.now()}`, file: null },
        { id: 2, localUrl: getFotoUrl('execucao', 2) + `?v=${Date.now()}`, file: null },
        { id: 3, localUrl: getFotoUrl('execucao', 3) + `?v=${Date.now()}`, file: null },
      ]);
    }
  }, [osData]);

  // Buscar gestores (grupo_id=2) ao carregar se action=gestor
  useEffect(() => {
    if (action === "gestor" && unidade) {
      fetch(ENDPOINTS.USUARIO_LIST, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ unidade, grupo_id: 2 })
      })
        .then(res => res.json())
        .then(data => {
          // Filtra e mapeia apenas gestores
          const gestores = (Array.isArray(data) ? data : [])
            .filter((u: any) => u.grupo_id === 2)
            .map((u: any) => ({ id: u.id, nome: u.nome }));
          setGestores(gestores);
        });
    }
  }, [action, unidade]);

  // Função utilitária para obter URL das fotos
  function getFotoUrl(tipo: 'chamado' | 'execucao', idx: number) {
    return getMinioFileUrl({ unidade, tipo, osId, fotoNum: idx });
  }

  // Prioridades disponíveis
  const prioridades = [
    "AGUARDANDO",
    "EMERGENCIAL",
    "ALTA",
    "MEDIA",
    "BAIXA"
  ];

  // Função para distribuir OS
  async function handleDistribuir() {
    if (!executorSelecionado || !prioridadeSelecionada || !obsValidador.trim()) {
      setToast({ open: true, message: 'Preencha todos os campos obrigatórios!', type: 'error' });
      setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
      return;
    }
    setDistribuindo(true);
    try {
      const prioridadeIdMap: Record<string, number> = {
        'AGUARDANDO': 1,
        'BAIXA': 2,
        'MEDIA': 3,
        'ALTA': 4,
        'EMERGENCIAL': 5,
      };
      const payload = {
        unidade: (unidade || '').toLowerCase(),
        id: osData?.id,
        dth_distribuido: new Date().toISOString().slice(0, 19).replace('T', ' '),
        status_id: 2,
        usuario_os: Number(executorSelecionado),
        obs_adm: obsValidador,
        prioridade_id: prioridadeIdMap[prioridadeSelecionada.trim().toUpperCase()]
      };
      const response = await fetch(ENDPOINTS.OS_DISTRIBUIR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (Array.isArray(data) && data[0]?.success) {
        // Buscar nome do executor selecionado
        const exec = executores.find(e => String(e.id) === String(executorSelecionado));
        setExecutorNome(exec ? exec.nome : "");
        setDistribuidaComSucesso(true);
      } else {
        setToast({ open: true, message: 'Erro ao distribuir OS!', type: 'error' });
        setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
      }
    } catch {
      setToast({ open: true, message: 'Erro de conexão ao distribuir OS!', type: 'error' });
      setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
    } finally {
      setDistribuindo(false);
    }
  }

  async function handleAceitar() {
    if (!dataHoraVisita) {
      setToast({ open: true, message: 'Escolha a data e hora para agendar!', type: 'error' });
      setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
      return;
    }
    setAceitando(true);
    try {
      const payload = {
        unidade: (unidade || '').toLowerCase(),
        id: osData?.id,
        dth_aceita: formatDateTimeLocal(new Date()),
        dth_agenda: formatDateTimeLocal(dataHoraVisita)
      };
      const response = await fetch(ENDPOINTS.OS_ACEITAR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (Array.isArray(data) && data[0]?.success) {
        setAceitaComSucesso(true);
      } else {
        setToast({ open: true, message: 'Erro ao aceitar OS!', type: 'error' });
        setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
      }
    } catch {
      setToast({ open: true, message: 'Erro de conexão ao aceitar OS!', type: 'error' });
      setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
    } finally {
      setAceitando(false);
    }
  }

  // Manipulação de fotos de execução
  function handleFotoExecChange(idx: number, file: File) {
    const url = URL.createObjectURL(file);
    setFotosExec(fotos => fotos.map((f, i) => i === idx ? { ...f, localUrl: url, file: file } : f));
  }
  function handleFotoExecLimpar(idx: number) {
    setFotosExec(fotos => fotos.map((f, i) => i === idx ? { ...f, localUrl: "", file: null } : f));
  }

  // Função para gravar dados de execução
  async function handleGravarExec() {
    setGravando(true);
    try {
      const payload = {
        unidade: (unidade || '').toLowerCase(),
        id: osData?.id,
        descricao_servico_executar: descServico,
        materiais_necessarios: materiais,
        equipamentos_necessarios: equipamentos,
        profissionais_envolvidos: profissionais
      };
      const response = await fetch(ENDPOINTS.OS_GRAVAR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (Array.isArray(data) && data[0]?.success) {
        setToast({ open: true, message: 'Alterações salvas com sucesso!', type: 'success' });
        setTimeout(() => setToast(t => ({ ...t, open: false })), 2000);
      } else {
        setToast({ open: true, message: 'Erro ao salvar alterações!', type: 'error' });
        setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
      }
    } catch {
      setToast({ open: true, message: 'Erro de conexão ao salvar!', type: 'error' });
      setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
    } finally {
      setGravando(false);
    }
  }

  // Função para finalizar OS
  async function handleFinalizar() {
    setFinalizando(true);
    try {
      await handleGravarExec(); // Grava antes de finalizar
      const payload = {
        unidade: (unidade || '').toLowerCase(),
        id: osData?.id,
        dth_fim: new Date().toISOString().slice(0, 19).replace('T', ' '),
        os_gestor: osData?.gestor_id,
        usuario_os: osData?.executor_id
      };
      const response = await fetch(ENDPOINTS.OS_FINALIZAR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (Array.isArray(data) && data[0]?.success) {
        setFinalizadaComSucesso(true);
      } else {
        setToast({ open: true, message: 'Erro ao finalizar OS!', type: 'error' });
        setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
      }
    } catch {
      setToast({ open: true, message: 'Erro de conexão ao finalizar OS!', type: 'error' });
      setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
    } finally {
      setFinalizando(false);
    }
  }

  // Função para cancelar OS
  async function handleCancelar() {
    setCancelando(true);
    try {
      await handleGravarExec(); // Grava antes de cancelar
      const payload = {
        unidade: (unidade || '').toLowerCase(),
        id: osData?.id,
        dth_fim: new Date().toISOString().slice(0, 19).replace('T', ' '),
        os_gestor: osData?.gestor_id,
        usuario_os: osData?.executor_id
      };
      const response = await fetch(ENDPOINTS.OS_CANCELAR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (Array.isArray(data) && data[0]?.success) {
        setCanceladaComSucesso(true);
      } else {
        setToast({ open: true, message: 'Erro ao cancelar OS!', type: 'error' });
        setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
      }
    } catch {
      setToast({ open: true, message: 'Erro de conexão ao cancelar OS!', type: 'error' });
      setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
    } finally {
      setCancelando(false);
    }
  }

  // Upload das fotos de execução
  async function handleUploadFotosExec() {
    for (const foto of fotosExec) {
      if (foto.file) {
        try {
          await uploadToMinio({
            file: foto.file,
            unidade,
            tipo: 'execucao',
            osId: String(osData?.id ?? ''),
            fotoNum: foto.id
          });
        } catch {
          setToast({ open: true, message: 'Erro ao enviar foto de execução', type: 'error' });
          setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
        }
      }
    }
  }

  // Adicione as funções abaixo no componente:
  function handleFotoChamadoChange(idx: number, file: File) {
    if (osData && typeof osData.id === 'number') {
      uploadToMinio({
        file,
        unidade,
        tipo: 'chamado',
        osId: String(osData.id),
        fotoNum: idx
      }).then(() => setToast({ open: true, message: 'Foto enviada com sucesso!', type: 'success' }))
        .catch(() => setToast({ open: true, message: 'Erro ao enviar foto', type: 'error' }));
    }
  }
  function handleFotoChamadoLimpar(idx: number) {
    if (osData && typeof osData.id === 'number') {
      deleteFromMinio({
        unidade,
        tipo: 'chamado',
        osId: String(osData.id),
        fotoNum: idx
      }).then(() => setToast({ open: true, message: 'Foto removida com sucesso!', type: 'success' }))
        .catch(() => setToast({ open: true, message: 'Erro ao remover foto', type: 'error' }));
    }
  }

  // Função para atribuir gestor
  async function handleAtribuirGestor() {
    if (!gestorSelecionado || !prioridadeGestor) {
      setToast({ open: true, message: 'Selecione gestor e prioridade!', type: 'error' });
      setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
      return;
    }
    setAtribuindo(true);
    // Mapear prioridade para o id correto
    const prioridadeIdMap: Record<string, number> = {
      'AGUARDANDO': 1,
      'BAIXA': 2,
      'MEDIA': 3,
      'ALTA': 4,
      'EMERGENCIAL': 5,
    };
    const prioridade_id = prioridadeIdMap[prioridadeGestor.trim().toUpperCase()] || 1;
    const obs_adm = obsAdmin.trim() ? obsAdmin : 'sem observações';
    try {
      const response = await fetch(ENDPOINTS.OS_ATRIBUIR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          unidade: (unidade || '').toLowerCase(),
          id: osData?.id,
          os_gestor: Number(gestorSelecionado),
          prioridade_id,
          obs_adm
        })
      });
      const data = await response.json();
      if (Array.isArray(data) && data[0]?.success) {
        // Buscar nome do gestor selecionado
        const gestor = gestores.find(g => String(g.id) === String(gestorSelecionado));
        setNomeGestorAtribuido(gestor ? gestor.nome : '');
        setAtribuidoComSucesso(true);
      } else {
        setToast({ open: true, message: 'Erro ao atribuir gestor!', type: 'error' });
        setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
      }
    } catch {
      setToast({ open: true, message: 'Erro de conexão ao atribuir gestor!', type: 'error' });
      setTimeout(() => setToast(t => ({ ...t, open: false })), 3000);
    } finally {
      setAtribuindo(false);
    }
  }

  // Preencher data/hora atual ao abrir tela de execução (action=execute)
  useEffect(() => {
    if (action === "execute" && !dataHoraVisita) {
      setDataHoraVisita(new Date());
    }
  }, [action]);

  if (loading) return <Loader />;
  if (!osData) return <div className="p-8 text-center text-red-600 font-bold">OS não encontrada.</div>;

  if (action === "gestor") {
    // Fluxo de pré-autorização via administrador
    return (
      <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-start p-2">
        {toast.open && (
          <div className={`fixed top-6 left-1/2 z-[9999] -translate-x-1/2 px-6 py-3 rounded shadow-lg text-white font-semibold transition-all ${toast.type === 'error' ? 'bg-red-600' : 'bg-green-600'}`}>{toast.message}</div>
        )}
        <div className="w-full max-w-md bg-white rounded-lg shadow p-4 mt-4">
          <div className="text-center font-bold text-2xl mb-4 text-blue-700">PRÉ AUTORIZAÇÃO VIA ADMINISTRADOR</div>
          <div className="mb-4">
            <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">OS:</b> <span className="text-gray-800">{osData?.id}</span></div>
            <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Data/Hora Abertura:</b> <span className="text-gray-800">{
              osData?.data_abertura
                ? (() => {
                    let d = osData.data_abertura;
                    if (/^\d{4}-\d{2}-\d{2}$/.test(d)) {
                      return new Date(d + 'T00:00:00-03:00').toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
                    } else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(d)) {
                      return new Date(d.replace(' ', 'T') + '-03:00').toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
                    } else {
                      return new Date(d).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
                    }
                  })()
                : '-'}</span></div>
            <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Solicitante:</b> <span className="text-gray-800">{osData?.solicitante_nome}</span></div>
            <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Descrição:</b> <span className="text-gray-800">{osData?.descricao_os}</span></div>
          </div>
          <div className="mb-4">
            <label className="block text-xs font-semibold text-gray-700 mb-1">Observação do Administrador</label>
            <textarea
              className="w-full bg-blue-50 border border-blue-300 p-2 text-base text-black rounded"
              rows={2}
              value={obsAdmin}
              onChange={e => setObsAdmin(e.target.value)}
              placeholder="Digite uma observação para o gestor (opcional)"
              disabled={atribuindo || atribuidoComSucesso}
            />
          </div>
          {/* Select de Gestor */}
          <div className="mb-4">
            <label className="block text-xs font-semibold text-gray-700 mb-1">Gestor Responsável</label>
            {gestores.length === 0 ? (
              <div className="text-red-600 text-sm">Nenhum gestor disponível para atribuição.</div>
            ) : (
              <select
                className="w-full bg-blue-50 border border-blue-300 p-2 text-base text-black rounded"
                value={gestorSelecionado}
                onChange={e => setGestorSelecionado(e.target.value)}
                disabled={atribuindo || atribuidoComSucesso}
              >
                <option value="">Selecione o gestor</option>
                {gestores.map(g => (
                  <option key={g.id} value={g.id}>{g.nome}</option>
                ))}
              </select>
            )}
          </div>
          {/* Select de Prioridade */}
          <div className="mb-4">
            <label className="block text-xs font-semibold text-gray-700 mb-1">Prioridade</label>
            <select
              className="w-full bg-blue-50 border border-blue-300 p-2 text-base text-black rounded"
              value={prioridadeGestor}
              onChange={e => setPrioridadeGestor(e.target.value)}
              disabled={atribuindo || atribuidoComSucesso}
            >
              <option value="">Selecione a prioridade</option>
              {prioridades.map(prio => (
                <option key={prio} value={prio}>{prio.charAt(0) + prio.slice(1).toLowerCase()}</option>
              ))}
            </select>
          </div>
          {/* Foto da OS para o administrador visualizar */}
          <div className="mb-4 flex flex-col items-center">
            <img
              src={osData?.url_foto ? osData.url_foto : getFotoUrl('chamado', 1) + `?v=${Date.now()}`}
              alt="Foto da OS"
              className="object-contain rounded border w-full max-w-full cursor-zoom-in"
              style={{ maxWidth: '100%', height: '220px', background: '#f3f4f6' }}
              onError={e => (e.currentTarget.src = 'https://cdn-icons-png.flaticon.com/512/2748/2748558.png')}
              onClick={() => {
                setFotoModalUrl(osData?.url_foto ? osData.url_foto : getFotoUrl('chamado', 1));
                setModalFotoAberto(true);
              }}
            />
            <span className="text-xs text-gray-600 mt-1">Foto do Chamado</span>
          </div>
          {/* Modal de visualização da foto em tela cheia com zoom/pinch */}
          {modalFotoAberto && fotoModalUrl && (
            <div
              className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-90"
              style={{ touchAction: 'none' }}
              onClick={e => {
                if (e.target === e.currentTarget) setModalFotoAberto(false);
              }}
            >
              <button
                className="absolute top-4 right-4 bg-white text-black rounded-full p-2 shadow-lg text-2xl z-50"
                onClick={() => setModalFotoAberto(false)}
                aria-label="Fechar"
                style={{ minWidth: 44, minHeight: 44 }}
              >
                ×
              </button>
              <img
                src={fotoModalUrl}
                alt="Foto em tela cheia"
                className="object-contain max-h-[90vh] max-w-[95vw] select-none"
                style={{
                  touchAction: 'pinch-zoom',
                  background: '#222',
                  borderRadius: 8,
                  boxShadow: '0 0 24px #0008',
                  userSelect: 'none',
                }}
                draggable={false}
              />
              <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white text-xs opacity-80">Use dois dedos para dar zoom</div>
            </div>
          )}
          {/* Botão ATRIBUIR só aparece se gestor e prioridade estiverem preenchidos */}
          {(!atribuidoComSucesso && gestorSelecionado && prioridadeGestor) && (
          <button
            className={`w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 rounded transition ${atribuindo ? 'opacity-60 cursor-not-allowed' : ''}`}
            onClick={handleAtribuirGestor}
            disabled={atribuindo}
          >
            {atribuindo ? 'Atribuindo...' : 'ATRIBUIR'}
          </button>
          )}
          {atribuidoComSucesso && (
            <div className="mt-4 p-4 bg-green-600 text-white rounded-lg text-center font-bold text-lg shadow">
              Ordem de Serviço Atribuída para o Gestor {nomeGestorAtribuido}
            </div>
          )}
        </div>
      </div>
    );
  }

  // Fluxo de distribuição para EXECUTOR (inclui action === 'validate')
  if (action === "validate" || osData?.status_descricao === "AGUARDANDO") {
    return (
      <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-start p-2">
        {toast.open && (
          <div className={`fixed top-6 left-1/2 z-[9999] -translate-x-1/2 px-6 py-3 rounded shadow-lg text-white font-semibold transition-all ${toast.type === 'error' ? 'bg-red-600' : 'bg-green-600'}`}>{toast.message}</div>
        )}
        <div className="w-full max-w-md bg-white rounded-lg shadow p-4 mt-4">
          <div className="text-center font-bold text-2xl mb-4 text-blue-700">Ordem de Serviço #{osData?.id}</div>
          <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Departamento:</b> <span className="text-gray-800">{osData?.departamento_descricao}</span></div>
          <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Local:</b> <span className="text-gray-800">{osData?.local_descricao}</span></div>
          <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Solicitante:</b> <span className="text-gray-800">{osData?.solicitante_nome}</span></div>
          <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Status:</b> <span className="text-gray-800">{osData?.status_descricao}</span></div>
          <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Prioridade:</b> <span className="text-gray-800">{osData?.prioridade_descricao}</span></div>
          <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Descrição:</b> <span className="text-gray-800">{osData?.descricao_os}</span></div>
          {/* Bloco de distribuição para status AGUARDANDO ou action=validate */}
          {!distribuidaComSucesso ? (
            <div className="mt-6 p-3 rounded bg-yellow-50 border border-yellow-200">
              <div className="font-bold text-base mb-2 text-yellow-700">Distribuição da OS</div>
              <div className="mb-2">
                <label className="block text-xs font-semibold text-gray-700 mb-1">Observação DO VALIDADOR</label>
                <textarea
                  className="w-full bg-yellow-100 border border-yellow-300 p-2 text-base text-black rounded"
                  rows={2}
                  value={obsValidador}
                  onChange={e => setObsValidador(e.target.value)}
                />
              </div>
              <div className="mb-2">
                <label className="block text-xs font-semibold text-gray-700 mb-1">Executor</label>
                <select
                  className="w-full bg-yellow-100 border border-yellow-300 p-2 text-base text-black rounded"
                  value={executorSelecionado}
                  onChange={e => setExecutorSelecionado(e.target.value)}
                >
                  <option value="">Selecione o executor</option>
                  {executores.map(exec => (
                    <option key={exec.id} value={exec.id}>{exec.nome}</option>
                  ))}
                </select>
              </div>
              <div className="mb-4">
                <label className="block text-xs font-semibold text-gray-700 mb-1">Prioridade</label>
                <select
                  className="w-full bg-yellow-100 border border-yellow-300 p-2 text-base text-black rounded"
                  value={prioridadeSelecionada}
                  onChange={e => setPrioridadeSelecionada(e.target.value)}
                >
                  <option value="">Selecione a prioridade</option>
                  {prioridades.map(prio => (
                    <option key={prio} value={prio}>{prio.charAt(0) + prio.slice(1).toLowerCase()}</option>
                  ))}
                </select>
              </div>
              <div className="flex gap-2">
                <button
                  className={`flex-1 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold py-2 rounded transition ${distribuindo ? 'opacity-60 cursor-not-allowed' : ''}`}
                  onClick={handleDistribuir}
                  disabled={distribuindo || !executorSelecionado || !prioridadeSelecionada || !obsValidador.trim()}
                >
                  {distribuindo ? 'Distribuindo...' : 'DISTRIBUIR'}
                </button>
                <button
                  className="flex-1 bg-gray-400 hover:bg-gray-500 text-white font-bold py-2 rounded transition"
                  onClick={() => window.history.back()}
                >
                  FECHAR
                </button>
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-8 bg-green-600 rounded-lg shadow-lg mt-6">
              <div className="flex items-center gap-3 mb-4">
                <span className="text-5xl">✅</span>
                <span className="text-2xl font-bold text-white text-center">ORDEM DE SERVIÇO DISTRIBUÍDA PARA O EXECUTOR : {executorNome}</span>
              </div>
            </div>
          )}
          {/* Foto da OS para o gestor visualizar */}
          <div className="mb-4 flex flex-col items-center mt-6">
            <img
              src={osData?.url_foto ? osData.url_foto : getFotoUrl('chamado', 1) + `?v=${Date.now()}`}
              alt="Foto da OS"
              className="object-contain rounded border w-full max-w-full cursor-zoom-in"
              style={{ maxWidth: '100%', height: '220px', background: '#f3f4f6' }}
              onError={e => (e.currentTarget.src = 'https://cdn-icons-png.flaticon.com/512/2748/2748558.png')}
              onClick={() => {
                setFotoModalUrl(osData?.url_foto ? osData.url_foto : getFotoUrl('chamado', 1));
                setModalFotoAberto(true);
              }}
            />
            <span className="text-xs text-gray-600 mt-1">Foto do Chamado</span>
          </div>
          {/* Modal de visualização da foto em tela cheia com zoom/pinch */}
          {modalFotoAberto && fotoModalUrl && (
            <div
              className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-90"
              style={{ touchAction: 'none' }}
              onClick={e => {
                if (e.target === e.currentTarget) setModalFotoAberto(false);
              }}
            >
              <button
                className="absolute top-4 right-4 bg-white text-black rounded-full p-2 shadow-lg text-2xl z-50"
                onClick={() => setModalFotoAberto(false)}
                aria-label="Fechar"
                style={{ minWidth: 44, minHeight: 44 }}
              >
                ×
              </button>
              <img
                src={fotoModalUrl}
                alt="Foto em tela cheia"
                className="object-contain max-h-[90vh] max-w-[95vw] select-none"
                style={{
                  touchAction: 'pinch-zoom',
                  background: '#222',
                  borderRadius: 8,
                  boxShadow: '0 0 24px #0008',
                  userSelect: 'none',
                }}
                draggable={false}
              />
              <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white text-xs opacity-80">Use dois dedos para dar zoom</div>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (action === "execute" && osData?.status_descricao === "DISTRIBUIDA" && !aceitaComSucesso) {
    return (
      <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-start p-2">
        {toast.open && (
          <div className={`fixed top-6 left-1/2 z-[9999] -translate-x-1/2 px-6 py-3 rounded shadow-lg text-white font-semibold transition-all ${toast.type === 'error' ? 'bg-red-600' : 'bg-green-600'}`}>{toast.message}</div>
        )}
        <div className="w-full max-w-md bg-white rounded-lg shadow p-4 mt-4">
          <div className="text-center font-bold text-2xl mb-4 text-blue-700">Aceitar Ordem de Serviço</div>
          <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Departamento:</b> <span className="text-gray-800">{osData?.departamento_descricao}</span></div>
          <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Local:</b> <span className="text-gray-800">{osData?.local_descricao}</span></div>
          <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Solicitante:</b> <span className="text-gray-800">{osData?.solicitante_nome}</span></div>
          <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Status:</b> <span className="text-gray-800">{osData?.status_descricao}</span></div>
          <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Prioridade:</b> <span className="text-gray-800">{osData?.prioridade_descricao}</span></div>
          <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Descrição:</b> <span className="text-gray-800">{osData?.descricao_os}</span></div>
          {/* Foto da OS para o executor visualizar */}
          <div className="mb-4 flex flex-col items-center mt-6">
            <img
              src={osData?.url_foto ? osData.url_foto : getFotoUrl('chamado', 1) + `?v=${Date.now()}`}
              alt="Foto da OS"
              className="object-contain rounded border w-full max-w-full cursor-zoom-in"
              style={{ maxWidth: '100%', height: '220px', background: '#f3f4f6' }}
              onError={e => (e.currentTarget.src = 'https://cdn-icons-png.flaticon.com/512/2748/2748558.png')}
              onClick={() => {
                setFotoModalUrl(osData?.url_foto ? osData.url_foto : getFotoUrl('chamado', 1));
                setModalFotoAberto(true);
              }}
            />
            <span className="text-xs text-gray-600 mt-1">Foto do Chamado</span>
          </div>
          {/* Modal de visualização da foto em tela cheia com zoom/pinch */}
          {modalFotoAberto && fotoModalUrl && (
            <div
              className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-90"
              style={{ touchAction: 'none' }}
              onClick={e => {
                if (e.target === e.currentTarget) setModalFotoAberto(false);
              }}
            >
              <button
                className="absolute top-4 right-4 bg-white text-black rounded-full p-2 shadow-lg text-2xl z-50"
                onClick={() => setModalFotoAberto(false)}
                aria-label="Fechar"
                style={{ minWidth: 44, minHeight: 44 }}
              >
                ×
              </button>
              <img
                src={fotoModalUrl}
                alt="Foto em tela cheia"
                className="object-contain max-h-[90vh] max-w-[95vw] select-none"
                style={{
                  touchAction: 'pinch-zoom',
                  background: '#222',
                  borderRadius: 8,
                  boxShadow: '0 0 24px #0008',
                  userSelect: 'none',
                }}
                draggable={false}
              />
              <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white text-xs opacity-80">Use dois dedos para dar zoom</div>
            </div>
          )}
          {/* Bloco para aceitar OS */}
          <div className="mt-6 p-3 rounded bg-cyan-50 border border-cyan-200">
            <div className="mb-2">
              <label className="block text-xs font-semibold text-gray-700 mb-1">Data e hora que irá ao local</label>
              <input
                id="input-data-hora-visita"
                type="datetime-local"
                value={dataHoraVisita ? dataHoraVisita.toISOString().slice(0, 16) : ''}
                onChange={e => setDataHoraVisita(e.target.value ? new Date(e.target.value) : null)}
                className="border rounded p-2 w-full text-black"
                placeholder="Clique para escolher"
                disabled={aceitando}
              />
            </div>
            <div className="flex gap-2 mt-4">
              <button
                className={`flex-1 bg-cyan-400 hover:bg-cyan-500 text-white font-bold py-2 rounded transition ${aceitando ? 'opacity-60 cursor-not-allowed' : ''}`}
                onClick={handleAceitar}
                disabled={aceitando || !dataHoraVisita}
              >
                {aceitando ? 'Aceitando...' : 'ACEITAR'}
              </button>
              <button
                className="flex-1 bg-gray-400 hover:bg-gray-500 text-white font-bold py-2 rounded transition"
                onClick={() => window.history.back()}
              >
                FECHAR
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-start p-2">
      {toast.open && (
        <div className={`fixed top-6 left-1/2 z-[9999] -translate-x-1/2 px-6 py-3 rounded shadow-lg text-white font-semibold transition-all ${toast.type === 'error' ? 'bg-red-600' : 'bg-green-600'}`}>{toast.message}</div>
      )}
      <div className="w-full max-w-md bg-white rounded-lg shadow p-4 mt-4">
        {distribuidaComSucesso ? (
          <div className="flex flex-col items-center justify-center py-8 bg-green-600 rounded-lg shadow-lg">
            <div className="flex items-center gap-3 mb-4">
              <span className="text-5xl">✅</span>
              <span className="text-2xl font-bold text-white text-center">ORDEM DE SERVIÇO DISTRIBUÍDA COM SUCESSO</span>
            </div>
            <div className="w-full text-left text-base mb-2 text-white"><b>OS:</b> {osData.id}</div>
            <div className="w-full text-left text-base mb-2 text-white"><b>DEPARTAMENTO:</b> {osData.departamento_descricao}</div>
            <div className="w-full text-left text-base mb-2 text-white"><b>SALA/AMBIENTE:</b> {osData.local_descricao}</div>
            <div className="w-full text-left text-base mb-2 text-white"><b>SOLICITANTE:</b> {osData.solicitante_nome}</div>
            <div className="w-full text-left text-base mb-2 text-white"><b>SERVIÇO SOLICITADO:</b> {osData.descricao_os}</div>
            <div className="w-full text-left text-base mb-2 text-white"><b>EXECUTOR:</b> {executorNome}</div>
          </div>
        ) : (
          <>
            <div className="text-center font-bold text-2xl mb-4 text-blue-700">Ordem de Serviço #{osData.id}</div>
            <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Departamento:</b> <span className="text-gray-800">{osData.departamento_descricao}</span></div>
            <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Local:</b> <span className="text-gray-800">{osData.local_descricao}</span></div>
            <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Solicitante:</b> <span className="text-gray-800">{osData.solicitante_nome}</span></div>
            <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Status:</b> <span className="text-gray-800">{osData.status_descricao}</span></div>
            <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Prioridade:</b> <span className="text-gray-800">{osData.prioridade_descricao}</span></div>
            <div className="mb-2 text-sm"><b className="text-gray-700 font-bold">Descrição:</b> <span className="text-gray-800">{osData.descricao_os}</span></div>
            {/* Bloco de distribuição para status AGUARDANDO */}
            {osData?.status_descricao === "AGUARDANDO" && (
              <div className="mt-6 p-3 rounded bg-yellow-50 border border-yellow-200">
                <div className="font-bold text-base mb-2 text-yellow-700">Distribuição da OS</div>
                <div className="mb-2">
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Observação DO VALIDADOR</label>
                  <textarea
                    className="w-full bg-yellow-100 border border-yellow-300 p-2 text-base text-black rounded"
                    rows={2}
                    value={obsValidador}
                    onChange={e => setObsValidador(e.target.value)}
                  />
                </div>
                <div className="mb-2">
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Executor</label>
                  <select
                    className="w-full bg-yellow-100 border border-yellow-300 p-2 text-base text-black rounded"
                    value={executorSelecionado}
                    onChange={e => setExecutorSelecionado(e.target.value)}
                  >
                    <option value="">Selecione o executor</option>
                    {executores.map(exec => (
                      <option key={exec.id} value={exec.id}>{exec.nome}</option>
                    ))}
                  </select>
                </div>
                <div className="mb-4">
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Prioridade</label>
                  <select
                    className="w-full bg-yellow-100 border border-yellow-300 p-2 text-base text-black rounded"
                    value={prioridadeSelecionada}
                    onChange={e => setPrioridadeSelecionada(e.target.value)}
                  >
                    <option value="">Selecione a prioridade</option>
                    {prioridades.map(prio => (
                      <option key={prio} value={prio}>{prio.charAt(0) + prio.slice(1).toLowerCase()}</option>
                    ))}
                  </select>
                </div>
                <div className="flex gap-2">
                  <button
                    className={`flex-1 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold py-2 rounded transition ${distribuindo ? 'opacity-60 cursor-not-allowed' : ''}`}
                    onClick={handleDistribuir}
                    disabled={distribuindo || !executorSelecionado || !prioridadeSelecionada || !obsValidador.trim()}
                  >
                    {distribuindo ? 'Distribuindo...' : 'DISTRIBUIR'}
                  </button>
                  <button
                    className="flex-1 bg-gray-400 hover:bg-gray-500 text-white font-bold py-2 rounded transition"
                    onClick={() => window.history.back()}
                  >
                    FECHAR
                  </button>
                </div>
              </div>
            )}
            {/* FLUXO EXECUTOR: action=execute e status DISTRIBUIDA */}
            {/* Mensagem de sucesso após aceitar */}
            {action === "execute" && aceitaComSucesso && (
              <div className="flex flex-col items-center justify-center py-8 bg-blue-600 rounded-lg shadow-lg">
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-5xl">👍</span>
                  <span className="text-2xl font-bold text-white text-center">ORDEM DE SERVIÇO ACEITA COM SUCESSO</span>
                </div>
                <div className="w-full text-left text-base mb-2 text-white"><b>OS:</b> {osData.id}</div>
                <div className="w-full text-left text-base mb-2 text-white"><b>DEPARTAMENTO:</b> {osData.departamento_descricao}</div>
                <div className="w-full text-left text-base mb-2 text-white"><b>SALA/AMBIENTE:</b> {osData.local_descricao}</div>
                <div className="w-full text-left text-base mb-2 text-white"><b>SOLICITANTE:</b> {osData.solicitante_nome}</div>
                <div className="w-full text-left text-base mb-2 text-white"><b>SERVIÇO SOLICITADO:</b> {osData.descricao_os}</div>
                <div className="w-full text-left text-base mb-2 text-white"><b>DATA/HORA VISITA:</b> {dataHoraVisita ? dataHoraVisita.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : ''}</div>
              </div>
            )}
            {/* FLUXO EXECUÇÃO: action=edit e status ACEITA */}
            {action === "edit" && osData?.status_descricao === "ACEITA" && !finalizadaComSucesso && !canceladaComSucesso && (
              <div className="mt-6">
                <div className="font-bold text-base mb-2 text-green-700">DADOS referente ao SERVIÇO em EXECUÇÃO</div>
                <div className="bg-green-50 border border-green-200 rounded p-3 mb-4">
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Descrição do serviço já realizado</label>
                  <textarea
                    className="w-full bg-yellow-100 border border-yellow-300 p-2 text-base text-black rounded mb-2"
                    rows={3}
                    value={descServico}
                    onChange={e => setDescServico(e.target.value)}
                  />
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Materiais necessários para execução</label>
                  <textarea
                    className="w-full bg-yellow-100 border border-yellow-300 p-2 text-base text-black rounded mb-2"
                    rows={2}
                    value={materiais}
                    onChange={e => setMateriais(e.target.value)}
                  />
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Equipamentos necessários para execução</label>
                  <textarea
                    className="w-full bg-yellow-100 border border-yellow-300 p-2 text-base text-black rounded mb-2"
                    rows={2}
                    value={equipamentos}
                    onChange={e => setEquipamentos(e.target.value)}
                  />
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Profissionais envolvidos na execução</label>
                  <textarea
                    className="w-full bg-yellow-100 border border-yellow-300 p-2 text-base text-black rounded"
                    rows={2}
                    value={profissionais}
                    onChange={e => setProfissionais(e.target.value)}
                  />
                </div>
                <div className="font-bold text-base mb-2 text-green-700">FOTOS referente ao SERVIÇO em EXECUÇÃO</div>
                <div className="grid grid-cols-1 gap-4 mb-4">
                  {fotosExec.map((foto, idx) => (
                    <div key={foto.id} className="flex flex-col items-center">
                      <img
                        src={foto.localUrl || 'https://cdn-icons-png.flaticon.com/512/2748/2748558.png'}
                        alt={`Foto execução ${idx+1}`}
                        className="object-contain rounded border w-full max-w-xs h-40 bg-gray-200 mb-1"
                      />
                      <div className="flex gap-2 mt-1">
                        <label className="bg-blue-600 hover:bg-blue-700 text-white rounded-full p-2 shadow cursor-pointer flex items-center justify-center" title="Enviar foto">
                          <i className="fa fa-camera"></i>
                          <input type="file" accept="image/*" capture="environment" className="hidden" onChange={e => e.target.files && e.target.files[0] && handleFotoExecChange(idx, e.target.files[0])} />
                        </label>
                        <button className="bg-red-600 hover:bg-red-700 text-white rounded-full p-2 shadow flex items-center justify-center cursor-pointer" title="Limpar foto" onClick={() => handleFotoExecLimpar(idx)}>
                          <i className="fa fa-trash"></i>
                        </button>
                      </div>
                      <span className="mt-2 text-xs font-semibold">FOTO[{foto.id}]</span>
                    </div>
                  ))}
                </div>
                <div className="flex flex-wrap gap-2 mt-4">
                  <button
                    className={`flex-1 bg-red-600 hover:bg-red-700 text-white font-bold py-2 rounded transition ${cancelando ? 'opacity-60 cursor-not-allowed' : ''}`}
                    onClick={handleCancelar}
                    disabled={cancelando || finalizando || gravando}
                  >
                    {cancelando ? 'Cancelando...' : 'CANCELAR'}
                  </button>
                  <button
                    className={`flex-1 bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 rounded transition ${gravando ? 'opacity-60 cursor-not-allowed' : ''}`}
                    onClick={async () => { await handleUploadFotosExec(); await handleGravarExec(); }}
                    disabled={gravando || cancelando || finalizando}
                  >
                    {gravando ? 'Gravando...' : 'GRAVAR'}
                  </button>
                  <button
                    className={`flex-1 bg-green-600 hover:bg-green-700 text-white font-bold py-2 rounded transition ${finalizando ? 'opacity-60 cursor-not-allowed' : ''}`}
                    onClick={async () => { await handleUploadFotosExec(); await handleFinalizar(); }}
                    disabled={finalizando || cancelando || gravando}
                  >
                    {finalizando ? 'Finalizando...' : 'FINALIZAR'}
                  </button>
                  <button
                    className="flex-1 bg-gray-400 hover:bg-gray-500 text-white font-bold py-2 rounded transition"
                    onClick={() => window.history.back()}
                    disabled={finalizando || cancelando || gravando}
                  >
                    FECHAR
                  </button>
                </div>
              </div>
            )}
            {/* Mensagem de sucesso após finalizar */}
            {action === "edit" && finalizadaComSucesso && (
              <div className="flex flex-col items-center justify-center py-8 bg-green-600 rounded-lg shadow-lg">
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-5xl">🏁</span>
                  <span className="text-2xl font-bold text-white text-center">ORDEM DE SERVIÇO FINALIZADA COM SUCESSO</span>
                </div>
                <div className="w-full text-left text-base mb-2 text-white"><b>OS:</b> {osData.id}</div>
                <div className="w-full text-left text-base mb-2 text-white"><b>DEPARTAMENTO:</b> {osData.departamento_descricao}</div>
                <div className="w-full text-left text-base mb-2 text-white"><b>SALA/AMBIENTE:</b> {osData.local_descricao}</div>
                <div className="w-full text-left text-base mb-2 text-white"><b>SOLICITANTE:</b> {osData.solicitante_nome}</div>
                <div className="w-full text-left text-base mb-2 text-white"><b>SERVIÇO SOLICITADO:</b> {osData.descricao_os}</div>
              </div>
            )}
            {/* Mensagem de sucesso após cancelar */}
            {action === "edit" && canceladaComSucesso && (
              <div className="flex flex-col items-center justify-center py-8 bg-red-600 rounded-lg shadow-lg">
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-5xl">❌</span>
                  <span className="text-2xl font-bold text-white text-center">ORDEM DE SERVIÇO CANCELADA</span>
                </div>
                <div className="w-full text-left text-base mb-2 text-white"><b>OS:</b> {osData.id}</div>
                <div className="w-full text-left text-base mb-2 text-white"><b>DEPARTAMENTO:</b> {osData.departamento_descricao}</div>
                <div className="w-full text-left text-base mb-2 text-white"><b>SALA/AMBIENTE:</b> {osData.local_descricao}</div>
                <div className="w-full text-left text-base mb-2 text-white"><b>SOLICITANTE:</b> {osData.solicitante_nome}</div>
                <div className="w-full text-left text-base mb-2 text-white"><b>SERVIÇO SOLICITADO:</b> {osData.descricao_os}</div>
              </div>
            )}
            {/* Bloco de fotos do chamado */}
            <div className="mt-4">
              <div className="font-bold text-base mb-2 text-blue-700">Fotos do Chamado</div>
              <div className="grid grid-cols-1 gap-2">
                {[1,2,3].map(idx => (
                  <div key={idx} className="flex flex-col items-center">
                    <img
                      src={idx === 1
                        ? (osData?.url_foto ? osData.url_foto : getFotoUrl('chamado', 1) + `?v=${Date.now()}`)
                        : getFotoUrl('chamado', idx) + `?v=${Date.now()}`}
                      alt={`Foto ${idx}`}
                      className="object-contain rounded border w-full max-w-xs h-40 bg-gray-200 mb-1 cursor-zoom-in"
                      onError={e => (e.currentTarget.src = 'https://cdn-icons-png.flaticon.com/512/2748/2748558.png')}
                      onClick={() => {
                        if (idx === 1) {
                          setFotoModalUrl(osData?.url_foto ? osData.url_foto : getFotoUrl('chamado', 1));
                        } else {
                          setFotoModalUrl(getFotoUrl('chamado', idx));
                        }
                        setModalFotoAberto(true);
                      }}
                    />
                    {(action === "edit" && osData?.status_descricao === "ACEITA") && (
                      <div className="flex gap-2 mt-1">
                        <label className="bg-blue-600 hover:bg-blue-700 text-white rounded-full p-2 shadow cursor-pointer flex items-center justify-center" title="Enviar foto">
                          <i className="fa fa-camera"></i>
                          <input type="file" accept="image/*" capture="environment" className="hidden" onChange={e => e.target.files && e.target.files[0] && handleFotoChamadoChange(idx, e.target.files[0])} />
                        </label>
                        <button className="bg-red-600 hover:bg-red-700 text-white rounded-full p-2 shadow flex items-center justify-center cursor-pointer" title="Limpar foto" onClick={() => handleFotoChamadoLimpar(idx)}>
                          <i className="fa fa-trash"></i>
                        </button>
                      </div>
                    )}
                    <span className="text-xs text-gray-600">FOTO[{idx}]</span>
                  </div>
                ))}
              </div>
            </div>
            {/* Aqui virão os blocos de fotos de execução, botões e ações conforme status e action */}
            <div className="mt-4 text-center text-xs text-gray-500">(Layout mobile em construção...)</div>
          </>
        )}
      </div>
    </div>
  );
} 